export default {
  title: 'Zahlungsinformationen verifiziert.',
  description: 'Deine Zahlungsinformationen wurden erfolgreich bestätigt.',
};
